import { ModelBase } from 'store/model-base';

export class WatchesActivationRequest extends ModelBase {
    public static storeName: string = 'watchesActivationRequest';

    public requestId: string;
    public imei: string;
    public iccid: string;
}
